import { initializeFilters } from '../elements/filters.js';

/**
 * @param {HTMLElement} $element
 * @param {Object} options
 * @param {String} options.filtersClass
 * @param {String} options.resultsContainerClass
 * @param {String} options.emptyContainerClass
 * @param {String} options.loadingContainerClass
 * @param {Object} options.filtersOptions
 */
export function initializeFilterable($element, options={}) {
  const context = getContext($element, options);
  if (!context) {
    return;
  }

  const { $filters } = context;
  const onChange = async event => {
    if (context.abortController) {
      context.abortController.abort();
    }
    context.abortController = new AbortController();

    const $loading = getLoadingContainer(context);
    renderContainer(context, $loading);

    const $results = await getResultsForFilters(context, event);
    renderContainer(context, $results);
  };
  const filtersOptions = Object.assign({ onChange }, options.filtersOptions);

  initializeFilters($filters, filtersOptions);
}

function getContext($element, options={}) {
  const $filters = $element.querySelector(`.${options.filtersClass}`);
  if (!$filters) {
    return null;
  }

  return {
    $element,
    $filters,
    options
  };
}

async function getResultsForFilters(context, { filters, updateHistory = false }) {
  const resultsUrl = getResultsUrlForFilters(filters);
  if (updateHistory) {
    history.pushState(null, null, resultsUrl);
  }

  const response = await fetch(resultsUrl, {
    signal: context.abortController.signal
  });
  const parser = new DOMParser();
  const dom = parser.parseFromString(await response.text(), 'text/html');
  const selector = getContainerSelector(context);
  return dom.querySelector(selector);
}

function getResultsUrlForFilters(filters) {
  const url = new URL(location.href);
  const searchParams = new URLSearchParams();
  for (const filterKey of filters.keys()) {
    searchParams.set(filterKey, 'on');
  }
  url.search = searchParams.toString();
  return url.toString();
}

function getLoadingContainer(context) {
  const $container = document.createElement('div');
  $container.classList.add(context.options.loadingContainerClass);
  return $container;
}

function getContainerSelector(context) {
  const { resultsContainerClass, emptyContainerClass, loadingContainerClass } = context.options;
  return `.${resultsContainerClass}, .${emptyContainerClass}, .${loadingContainerClass}`
}

function renderContainer(context, $container) {
  const { $element } = context;
  const selector = getContainerSelector(context);;
  $element.querySelector(selector).replaceWith($container);
}
